import { forwardRef, AriaAttributes, ReactElement } from "react";
import styles from "./Helper.module.scss";
import { FieldMessage } from "../../../components/FieldMessage";
import { SrOnly } from "../../../components/SrOnly";

export type HelperProps = {
  id?: string;
  // required?: boolean;
  hint?: ReactElement | string;
  description?: ReactElement | string;
  errorMessage?: ReactElement | string;
  /**
   * aria-live for the error message
   * @default assertive
   * @link https://www.w3.org/WAI/tutorials/forms/notifications/
   */
  errorAriaLive?: AriaAttributes["aria-live"];
  maxLength?: number;
  inputLength?: number;
  isTyping?: boolean;
  showCounter?: boolean;
};

export const Helper = forwardRef<HTMLDivElement, HelperProps>((props, ref) => {
  const {
    id,
    hint,
    description,
    errorAriaLive = "assertive",
    errorMessage,
    maxLength,
    isTyping,
    inputLength = 0,
    showCounter,
  } = props;

  return (
    <div className={styles["helper"]} ref={ref} id={id}>
      <FieldMessage
        className={styles["messages"]}
        hint={hint}
        description={description}
        errorAriaLive={errorAriaLive}
        errorMessage={errorMessage}
      />

      {showCounter ? (
        <div className={styles["counter"]}>
          <span aria-hidden="true">
            {inputLength}/{maxLength}
          </span>
        </div>
      ) : null}
      {isTyping && !!maxLength ? (
        maxLength - inputLength >= 1 ? (
          <SrOnly>
            {/* TODO: potential localization */}
            <span aria-live="polite" aria-atomic="true">{`${
              maxLength - inputLength
            } character${maxLength - inputLength !== 1 ? "s" : ""} left`}</span>
          </SrOnly>
        ) : (
          <SrOnly>
            {/* TODO: potential localization */}
            <span role="alert">Maximum characters count reached</span>
          </SrOnly>
        )
      ) : null}
    </div>
  );
});

Helper.displayName = "Helper";
